import { useId } from 'react';

import { cn } from '@design-system/helpers';

import filledBrainSvg from './brain-filled.svg?raw';

/** Figma filled brain used on the Knowledge Base page and the active omni tab. */
export function BrainFilledIcon({
  size = 36,
  className,
}: {
  size?: number;
  className?: string;
}) {
  const clipId = useId().replace(/:/g, '');
  const html = filledBrainSvg
    .replace(/clip0_0_4/g, clipId)
    .replace('width="36"', `width="${size}"`)
    .replace('height="36"', `height="${size}"`);

  return (
    <span
      aria-hidden='true'
      className={cn(
        'inline-flex shrink-0 [&_svg]:size-full! [&_svg]:max-h-full! [&_svg]:max-w-full!',
        className
      )}
      style={{ width: size, height: size }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
